const INBOX = require('INBOX');

INBOX.namespace('classes.RemoteClient', function () {
    return function (baseURL) {
        this.baseURL = baseURL;

        this.getSyncTag = function () {
            return 'mail-web-remote-client';
        };

        this.request = function (path, method, payload, success, failure) {
            var deferred = $.Deferred();
            $.ajax(this.baseURL + path, {
                retryLimit: 3,
                retryCount: 0,
                contentType: 'application/json',
                dataType: 'json',
                xhrFields: {
                    withCredentials: true
                },
                method: method || 'GET',
                data: payload ? JSON.stringify(payload) : null,
                success: function (d) {
                    deferred.resolve(d);
                    if (success) success(d);
                },
                error: function (jqXHR) {
                    this.retryCount++;
                    if (this.retryCount <= this.retryLimit && jqXHR.status != 401) {
                        var that = this;
                        setTimeout(function () {
                            $.ajax(that);
                        }, this.retryCount * 2000);
                    } else {
                        deferred.reject();
                        if (failure) failure();
                    }
                }
            });

            return deferred;
        };
    };
});
